import { render, staticRenderFns } from "./RequestTable.vue?vue&type=template&id=59b8e2a4&"
import script from "./RequestTable.vue?vue&type=script&lang=js&"
export * from "./RequestTable.vue?vue&type=script&lang=js&"
import style0 from "./RequestTable.vue?vue&type=style&index=0&id=59b8e2a4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports